import React from "react";
import { BsStars } from "react-icons/bs";
import { FaBolt } from "react-icons/fa";
import {
  MODEL_SPEED_SMARTER,
  MODEL_SPEED_FASTEST,
} from "../../Hooks/useProcessAiModelSpeed";

/**
 * Segmented control for ProcessWithAI `ModelSpeed`.
 */
function ModelSpeedToggle({
  value,
  onChange,
  disabled = false,
  segmentSmarterLabel,
  segmentFastestLabel,
  smarterTitle,
  fastestTitle,
  groupLabel,
  groupHint,
  /** Slightly tighter padding (e.g. MDT footer) */
  compact = false,
  /** Hide the small uppercase label (e.g. when the parent shows a heading) */
  hideGroupLabel = false,
}) {
  const pad = compact ? "px-2.5 py-1.5" : "px-3 py-2 sm:px-4 sm:py-2.5";
  const iconSize = compact ? "text-sm" : "text-base";

  const baseBtn = `flex flex-1 min-w-0 items-center justify-center gap-1.5 rounded-lg text-sm font-semibold transition-all duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#A4C639] focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-800 ${pad}`;

  const inactive =
    "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-white/70 dark:hover:bg-gray-600/50";
  const active =
    "bg-[#A4C639] text-gray-900 shadow-md ring-1 ring-black/5 dark:ring-white/10";

  return (
    <div
      className={`flex flex-col gap-1.5 ${disabled ? "opacity-60 pointer-events-none" : ""}`}
      title={groupHint}
    >
      {!hideGroupLabel && (
        <span className="text-[10px] font-bold uppercase tracking-wider text-gray-500 dark:text-gray-400">
          {groupLabel}
        </span>
      )}
      <div
        role="radiogroup"
        aria-label={groupLabel}
        className="inline-flex w-full sm:w-auto rounded-xl border border-gray-200 bg-gradient-to-b from-gray-100 to-gray-200/80 p-1 shadow-inner dark:border-gray-600 dark:from-gray-900 dark:to-gray-950"
      >
        <button
          type="button"
          role="radio"
          aria-checked={value === MODEL_SPEED_SMARTER}
          disabled={disabled}
          title={smarterTitle}
          className={`${baseBtn} ${value === MODEL_SPEED_SMARTER ? active : inactive}`}
          onClick={() => onChange?.(MODEL_SPEED_SMARTER)}
        >
          <BsStars className={`shrink-0 ${iconSize}`} aria-hidden />
          <span className="truncate">{segmentSmarterLabel}</span>
        </button>
        <button
          type="button"
          role="radio"
          aria-checked={value === MODEL_SPEED_FASTEST}
          disabled={disabled}
          title={fastestTitle}
          className={`${baseBtn} ${value === MODEL_SPEED_FASTEST ? active : inactive}`}
          onClick={() => onChange?.(MODEL_SPEED_FASTEST)}
        >
          <FaBolt className={`shrink-0 ${iconSize}`} aria-hidden />
          <span className="truncate">{segmentFastestLabel}</span>
        </button>
      </div>
    </div>
  );
}

export default ModelSpeedToggle;
